module.exports = __webpack_public_path__ + "img/tickets.664f8759.svg";